import { render } from "./device.vue?vue&type=template&id=054d5308&scoped=true&ts=true"
import script from "./device.vue?vue&type=script&lang=ts"
export * from "./device.vue?vue&type=script&lang=ts"

import "./device.vue?vue&type=style&index=0&id=054d5308&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-054d5308"]])

export default __exports__